export default "__VITE_ASSET__It19JYCg__"